import {useEffect, useRef, useState} from 'react';
import {useSignals} from '@preact/signals-react/runtime';
import {GoogleMap, Marker, useLoadScript} from '@react-google-maps/api';
import {eventInSingleEventPage} from '../../store/single-page.store';
import {whiteLabelStore} from "@/store/whitelabel.store";

interface Coordinates {
  lat: number;
  lng: number;
}

const containerStyle = {
  height: '240px',
  borderRadius: '6px',
  border: '1px solid #DCE0E7'
};

export default function GoogleMapCustom() {
  useSignals();

  const latitude = eventInSingleEventPage.value?.location?.lat;
  const longitude = eventInSingleEventPage.value?.location?.lon;

  const [position, setPosition] = useState<Coordinates>({
    lat: latitude ?? 0,
    lng: longitude ?? 0,
  });

  useEffect(() => {
    setPosition({ lat: latitude ?? 0, lng: longitude ?? 0 });
  }, [latitude, longitude]);

  const mapRef = useRef<google.maps.Map | null>(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY || whiteLabelStore.value?.googleMapsApiKey || ''
  });

  const handleLoad = (map: google.maps.Map) => {
    mapRef.current = map;
  };

  if (loadError) return <div>Failed to load Google Maps. Please try again later.</div>;
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div className="w-full lg:w-3/5" style={containerStyle}>
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '100%' }}
        center={position}
        zoom={16}
        onLoad={handleLoad}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: false,
          styles: [
            {
              featureType: "poi",
              elementType: "labels.text",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "poi",
              elementType: "labels.icon",
              stylers: [{ visibility: "on" }],
            },
            {
              featureType: "administrative",
              elementType: "labels",
              stylers: [{ visibility: "on" }],
            },
            {
              featureType: "transit",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "road",
              elementType: "labels.text",
              stylers: [{ visibility: "on" }],
            },
          ],
        }}
      >
        <Marker position={position} />
      </GoogleMap>
    </div>
  );

}
